export default __webpack_public_path__ + "static/media/640_store01-jp-mobile.fa8eed51.png";